import { GQLVehicleType } from "@src/graphql.apollo.generated";
import { Maybe } from "@src/graphql.gatsby.generated";
import React from "react";
import styled from "styled-components";

interface BadgeProps {
    type?: Maybe<GQLVehicleType>;
}

export const DebugBadge: React.FunctionComponent<BadgeProps> = ({ type }) => {
    if (!type) {
        return null;
    }
    return <Badge type={type}>{type}</Badge>;
};

const Badge = styled.span<BadgeProps>`
    margin-left: 25px;
    font-size: 16px;
    background-color: ${({ type }) => (type === GQLVehicleType.carHub ? "orange" : "black")};
    color: ${({ type }) => (type === GQLVehicleType.carHub ? "black" : "orange")};
    padding: 0px 10px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    border-radius: 5px;
`;
